import Types from '../Types';
const attemptFindAllGiveaways = (payload) => ({
  type: Types.FIND_ALL_GIVEAWAYS_ATTEMPT, payload
});

export default {
  attemptFindAllGiveaways
};


/** WEBPACK FOOTER **
 ** ./src/redux/giveaway/giveawayActions.js
 **/